// @ts-nocheck
import React, { useEffect, useState, useRef, useCallback } from "react";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid2";
import Autocomplete, { Option } from "../Autocomplete";
import {
  Checkbox,
  IconButton,
  Popover,
  styled,
  Switch,
  SwitchProps,
  useMediaQuery,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchProperties,
  fetchPropertiesFilters,
} from "../../redux/slice/propertiesSlice";
import {
  fetchStates,
  fetchCountiesByState,
} from "../../redux/slice/countyStateSlice";
import { fetchcalenderProperties } from "../../redux/slice/calenderPropertiesSlice";
import PropertyTypeAutocomplete from "../PropertyTypeAutocomplete";
import MoreFilter from "../MoreFilter";
import lodashDebounce from "lodash.debounce";
import { AppDispatch } from "../../redux/store";
import { useOutletContext } from "react-router-dom";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import MailIcon from "@mui/icons-material/Mail";
import { getFavorityProperty } from "../../redux/slice/favoritePropertySlice";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { Close } from "@mui/icons-material";
import NestedCheckboxList from "./NestedCheckboxList";
import ButtonComponents from "./ButtonComponents";
import moment from "moment";
const icon = (
  <CheckBoxOutlineBlankIcon fontSize="small" style={{ borderRadius: 4 }} />
);
const checkedIcon = (
  <CheckBoxIcon
    style={{ backgroundColor: "#FF5C39", color: "#fff", borderRadius: 4 }}
    fontSize="small"
  />
);

// Define types for your filters interface
interface PropertyFilter {
  id: number;
  code: string;
  filterDescription: string;
  filterTypeName: string;
  parentFilterId?: number;
}

interface PriceRange {
  min: string | number | null;
  max: string | number | null;
}

interface Range {
  min: string | number | null;
  max: string | number | null;
}

interface GroupedFilter {
  [key: string]: {
    [key: string]: any;
  };
}
// Typing the props for the TSwitch component
interface TSwitchProps extends SwitchProps {
  isRemoteBiddingEnable: boolean;
}
const PropertiesFilterHeader: React.FC = ({
  setPageNumber,
  setLoading,
  selectedState,
  selectedCounties,
  selectedAuctionStatus,
  setSelectedAuctionStatus,
  selectedPropertyType,
  setSelectedPropertyType,
  isRemoteBiddingEnable,
  setIsRemoteBiddingEnable,
  setSelectedCounties,
  setSelectedState,
  setReportedVacancy,
  setGeneralOccupancy,
  setPriceRange,
  setBeds,
  setBaths,
  setLotSize,
  setSquareFootage,
  setYearBuilt,
  priceRange,
  beds,
  baths,
  lotSize,
  squareFootage,
  yearBuilt,
  generalOccupancy,
  reportedVacancy,
  headertitle,
  isPropertyTab = false,
  isFilterOpen = false,
  setIsFilterOpen,
  fetchfavproperties,
  setCachedProperties,
  dateRange, 
  propertySortBy,
  setPropertySortBy
}) => {
  const [propertyState, setPropertyState] = useState<any[]>([]);
  const [allCounties, setAllCounties] = useState<any[]>([]);
  // const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [propertyType, setPropertyType] = useState<any[]>([]);
  const [auctionStatus, setAuctionStatus] = useState<any[]>([]);
  const [moreFilter, setMoreFilter] = useState<any[]>([]);
  const { states } = useSelector((state) => state.stateCounty || {});
  const isMobile = useOutletContext();
  const dispatch = useDispatch<AppDispatch>();
  const [open, setOpen] = useState(false);
  const [openType, setOpenType] = useState(false);
  const [openMore, setOpenMore] = useState(false);
  const [openStatus, setOpenStatus] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorElType, setAnchorElType] = useState(null);
  const [anchorElStatus, setAnchorElStatus] = useState(null);
  const { investorId } = useSelector((state) => state?.user);
  const [count, setCount] = useState(0);
  const handleOpen = (e, type) => {
    if (type === "more") {
      if (isMobile) {
        setOpenMore(true);
      } else {
        setOpen(true);
        setAnchorEl(e.currentTarget);
      }
    } else if (type === "status") {
      if (isMobile) {
        setOpenStatus(true);
      } else {
        setOpenStatus(true);
        setAnchorElStatus(e.currentTarget);
      }
    } else if (type === "type") {
      setOpenType(true);
      if (isMobile) {
        setOpenType(true);
      } else {
        setOpenType(true);
        setAnchorElType(e.currentTarget);
      }
    }
  };

  const handleClose = (type) => {
    if (type === "more") {
      setOpenMore(false);
    } else if (type === "status") {
      setOpenStatus(false);
    } else if (type === "type") {
      setOpenType(false);
    } else {
      setOpenMore(false);
      setOpenStatus(false);
      setOpenType(false);
      setIsFilterOpen && setIsFilterOpen(false);
      setOpen(false);
      setAnchorEl(null);
    }
  };
  const TSwitch = styled((props: any) => (
    <Switch
      disableRipple
      inputProps={{ 'aria-label': 'avaliable-serach-property' }}
      aria-label="Enable or disable remote bidding" // Updated the label for clarity
      {...props}
    />
  ))(({ theme }) => ({
    width: 38,
    height: 22,
    padding: 0,
    "& .MuiSwitch-switchBase": {
      padding: 0.5,
      margin: 2,
      transitionDuration: "300ms",
      "&.Mui-checked": {
        transform: "translateX(17px)",
        color: "#fff",
        "& + .MuiSwitch-track": {
          backgroundColor:
            isRemoteBiddingEnable === true ? "#ff5c397a" : "transparent",
          opacity: 1,
          border: "1px solid",
          borderColor: isRemoteBiddingEnable === true ? "#FF5C39" : "#9FA4AB",
        },
        "&.Mui-disabled + .MuiSwitch-track": {
          opacity: 0.5,
        },
      },
      "& + .MuiSwitch-track": {
        backgroundColor:
          isRemoteBiddingEnable === true ? "#ff5c397a" : "transparent",
        opacity: 1,
        border: "1px solid",
        borderColor: isRemoteBiddingEnable === true ? "#FF5C39" : "#9FA4AB",
      },
      "&.Mui-focusVisible .MuiSwitch-thumb": {
        color: "#FF5C39",
        border:
          isRemoteBiddingEnable === true
            ? "6px solid #FF5C39"
            : "6px solid #9FA4AB",
      },
      "&.Mui-disabled .MuiSwitch-thumb": {
        color: theme.palette.grey[100],
        ...theme.applyStyles("dark", {
          color: theme.palette.grey[600],
        }),
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.7,
        ...theme.applyStyles("dark", {
          opacity: 0.3,
        }),
      },
    },
    "&.MuiSwitch-track": {
      borderRadius: 26 / 2,
      backgroundColor:
        isRemoteBiddingEnable === true ? "#ff5c397a" : "transparent",
      opacity: 1,
      border: "1.5px solid",
      borderColor: isRemoteBiddingEnable === true ? "#FF5C39" : "#9FA4AB",
    },
    "& .MuiSwitch-thumb": {
      marginLeft: .5,
      marginRight: .5,
      marginTop: .5,
      width: 15,
      height: 15,
      color: isRemoteBiddingEnable === true ? "#FF5C39" : "#9FA4AB",
    },
    "& .MuiSwitch-track": {
      borderRadius: 26 / 2,
      backgroundColor: "#E9E9EA",
      opacity: 1,
      transition: theme.transitions.create(["background-color"], {
        duration: 500,
      }),
    },
  }));
  // To fetch the properties
  useEffect(() => {
    setLoading(true);
    setError(null);
    setPageNumber && setPageNumber(1)
    // Create a debounced version of the fetchingProperties function
    const debouncedFetchingProperties = lodashDebounce(async () => {
      try {
        const states = selectedState.map((state: any) => state.value);
        const counties = selectedCounties.map(
          (counties: any) => counties.value
        );
        const propertyType = selectedPropertyType.flatMap((type: any) =>
          type.value.split(",")
        );
        const auctionStatus = selectedAuctionStatus.map(
          (status: any) => status.value
        );
        const splitedAuctionStatus = auctionStatus.flatMap((item: any) =>
          item.split(",")
        );
        const propertyData = {
          pageNumber: 1,
          pageSize: 50,
          sortBy: "",
          sortDirection: propertySortBy,
          isRemoteBidding: isRemoteBiddingEnable,
          state: states || [],
          county: counties || [],
          auctionStatus: splitedAuctionStatus || [],
          propertyType: propertyType || [],
          occupancyStatus: generalOccupancy,
          reportVacant: reportedVacancy ? "YN_Y" : "",
          startPriceRange: priceRange.min ? parseInt(priceRange.min) : 0,
          endPriceRange: priceRange.max ? parseInt(priceRange.max) : 0,
          beds: beds === "Any" ? 0 : beds,
          baths: baths === "Any" ? 0 : baths,
          sqFtStartRange: squareFootage.min ? parseInt(squareFootage.min) : 0,
          sqFtEndRange: squareFootage.max ? parseInt(squareFootage.max) : 0,
          lotSizeStartRange:
            lotSize.min && !isNaN(lotSize.min) ? parseInt(lotSize.min) : 0,
          lotSizeEndRange:
            lotSize.max && !isNaN(lotSize.max) ? parseInt(lotSize.max) : 0,
          yearBuiltStartRange: yearBuilt.min ? parseInt(yearBuilt.min) : 0,
          yearBuiltEndRange: yearBuilt.max ? parseInt(yearBuilt.max) : 0,
        };
        if (window.location.pathname.includes("/auctioncalendar")) {
          let payload; 
          if (dateRange && dateRange.start && dateRange.end) {
            payload = {
              ...propertyData,
              startDate: moment(dateRange.start).format("YYYY-MM-DD"),
              endDate: moment(dateRange.end).format("YYYY-MM-DD"),
              investorId: investorId,
            };
            await dispatch(fetchcalenderProperties(payload)).unwrap();
          }

        } else {
          const response = await dispatch(fetchProperties(propertyData)).unwrap();
          console.log(response, "filter response")
          setCachedProperties(response)
        }
        setLoading(false);

      } catch (error: any) {
        console.log(error);
        setError(error);
        setLoading(false);
      }
    }, 600); // 600 ms debounce delay

    debouncedFetchingProperties();
    fetchfavproperties && fetchfavproperties();
    calculateSelectedFilters();
    // Cleanup function to cancel debounce timeout if dependencies change quickly
    return () => {
      debouncedFetchingProperties.cancel?.();
    };
  }, [
    isRemoteBiddingEnable,
    selectedState,
    selectedCounties,
    selectedAuctionStatus,
    selectedPropertyType,
    beds,
    baths,
    lotSize,
    priceRange,
    squareFootage,
    generalOccupancy,
    reportedVacancy,
    yearBuilt,
    propertySortBy
  ]);

  function groupAndAddGroupBy(array: PropertyFilter[]): any {
    const grouped: any = {};
    // First, organize grouped items by their `filterTypeName`
    array.forEach((item: PropertyFilter): any => {
      const parent = array.find((i) => i.id === item.parentFilterId);

      const formattedItem: {
        id: number;
        label: string;
        value: string;
        parentId?: number;
      } = {
        id: item.id,
        label: item.filterDescription, // Changed to `label`
        value: item.code,
      };

      // Handle relationships ONLY for "More Info" type
      if (item.filterTypeName === "More Info" && parent) {
        formattedItem.parentId = parent.id; // Establish parent-child relationships
      }

      if (!grouped[item.filterTypeName]) {
        grouped[item.filterTypeName] = {};
      }

      grouped[item.filterTypeName][item.filterDescription] = formattedItem;
    });

    // Nest Lot Size relationships
    const lotSizeParent = grouped["More Info"]["Lot Size"];
    const lotSizeChildren = Object.keys(grouped["More Info"]).filter(
      (child) => grouped["More Info"][child]?.parentId === lotSizeParent?.id
    );

    const lotSizeObject = lotSizeChildren.map((child) => ({
      id: grouped["More Info"][child].id,
      label: grouped["More Info"][child].label,
      value: grouped["More Info"][child].value,
    }));

    grouped["More Info"]["Lot Size"] = {
      id: lotSizeParent?.id,
      label: lotSizeParent?.label,
      value: lotSizeParent?.value,
      children: lotSizeObject,
    };

    // Clean children from flat data
    lotSizeChildren.forEach((child) => {
      delete grouped["More Info"][child];
    });

    // Nest Occupancy relationships
    const occupancyParent = grouped["More Info"]["Occupancy"];
    console.log(occupancyParent, "filter")
    const occupancyChildren = Object.keys(grouped["More Info"]).filter(
      (child) => grouped["More Info"][child]?.parentId === occupancyParent?.id
    );
    const occupancyObject = occupancyChildren.map((child) => ({
      id: grouped["More Info"][child].id,
      label: grouped["More Info"][child].label,
      value: grouped["More Info"][child].value,
    }));

    grouped["More Info"]["Occupancy"] = {
      id: occupancyParent?.id,
      label: occupancyParent?.label,
      value: occupancyParent?.value,
      children: occupancyObject,
    };

    occupancyChildren.forEach((child) => {
      delete grouped["More Info"][child];
    });

    return grouped;
  }
  function groupedAndAddGroupBy(array: PropertyFilter[]): {
    id: string | number;
    value: string;
    label: string;
    groupBy?: string;
  }[] {
    const grouped: {
      id: string | number;
      value: string;
      label: string;
      groupBy?: string;
    }[] = [];
    array.forEach((item) => {
      const parent = array.find((i) => i.id === item.parentFilterId);

      const formattedItem: {
        id: number;
        value: string;
        label: string;
        groupBy?: string;
      } = {
        id: item.id,
        value: item.code,
        label: item.filterDescription,
      };

      // Exclude groupBy for "Occupancy"
      if (item.filterTypeName === "Property Type") {
        formattedItem.groupBy = parent
          ? parent.filterDescription
          : item.filterDescription;
        // Exclude items from groups if their groupBy value matches their own label
      }
      grouped.push(formattedItem);
    });

    return grouped;
  }

  const fetchingStatesList = async () => {
    setError(null);
    try {
      dispatch(fetchStates());
      const filters = await dispatch(fetchPropertiesFilters()).unwrap();
      // Pass filters to the grouping function
      const auctionStatusData = filters.filter(
        (item: PropertyFilter) => item.filterTypeName === "Auction Status"
      );
      const propertyTypeData = filters.filter(
        (item: PropertyFilter) => item.filterTypeName === "Property Type"
      );
      const propertyType = groupedAndAddGroupBy(propertyTypeData);
      // const auctionStatus = groupedAndAddGroupBy(auctionStatusData);
      const groupedData = groupAndAddGroupBy(filters);
      console.log(groupedData, filters)
      setPropertyType(propertyType);
      setMoreFilter(groupedData["More Info"]);
      // setAuctionStatus(auctionStatus);
      setPropertyState(states);
    } catch (error: any) {
      setError("Error fetching states:", error);
    }
  };
  useEffect(() => {
    fetchingStatesList();
  }, []);

  function debounce(func, delay) {
    let timeoutId;
    return function (...args) {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      timeoutId = setTimeout(() => {
        func(...args);
      }, delay);
    };
  }

  const handleFetchCounty = async (newStates) => {
    if (newStates && newStates.length > 0) {
      // Start loading to fetch counties
      try {
        // Collect promises to fetch counties for each state
        const stateIds = newStates.map((state) => {
          return state.id; // Make sure to return the counties data from the action
        });

        const response = await dispatch(
          fetchCountiesByState(stateIds)
        ).unwrap();

        setAllCounties(response); // Set counties for selected states
      } catch (error: any) {
        setError("Error fetching counties:", error);
      }
    }
  };

  const handleStateChange = async (event, newStates) => {
    if (newStates.length === 0) {
      setSelectedCounties([]);
    }
    setSelectedState(newStates);
    setAllCounties([]); // Reset selected county list
    debounce(handleFetchCounty(newStates), 400);
  };

  const handleCountyChange = (event, newCounties) => {
    setSelectedCounties(newCounties);
  };

  // const debounceCountyChange = debounce(, 400);

  const handlePropertyTypeChange = (event, newValue) => {
    setSelectedPropertyType(newValue);
  };

  const handleAuctionStatusChange = (event, newValue) => {
    setSelectedAuctionStatus(newValue);
    // You can dispatch an action or update state here
  };
  const handleIsremoteBiddingEnable = () => {
    setIsRemoteBiddingEnable((prevState) => !prevState);
    setCachedProperties([])
  };

  const handleResetLocation = () => {
    setSelectedState([]);
    setAllCounties([]);
    setSelectedCounties([]);
  };
  const handleResetFilters = () => {
    setSelectedPropertyType([]);
    setSelectedAuctionStatus([]);
    handleClearMoreFilter();
  };

  const handleAuctionStatusChangeV2 = (option) => {
    setSelectedAuctionStatus((prev) => {
      const isSelected = prev.some((item) => item.id === option.id);
      return isSelected
        ? prev.filter((item) => item.id !== option.id) // Remove if already selected
        : [...prev, option]; // Add if not selected
    });
  };
  const handleClearMoreFilter = () => {
    setPriceRange({ min: null, max: null });
    setBeds("Any");
    setBaths("Any");
    setLotSize({
      min: "No Minimum",
      max: "No Maximum",
    });
    setSquareFootage({ min: null, max: null });
    setYearBuilt({ min: null, max: null });
    setGeneralOccupancy([]);
    setReportedVacancy(false);
  };
  const handleCloseMoreFilter = () => {
    setOpenMore(false);
    handleClearMoreFilter();
  };

  const calculateSelectedFilters = () => {
    let count = 0;

    // Check Price Range
    if (priceRange.min || priceRange.max) {
      count++;
    }

    // Check Beds
    if (beds !== "Any") {
      count++;
    }

    // Check Baths
    if (baths !== "Any") {
      count++;
    }

    // Check Lot Size
    if (lotSize.min !== "No Minimum" || lotSize.max !== "No Maximum") {
      count++;
    }

    // Check Square Footage
    if (squareFootage.min || squareFootage.max) {
      count++;
    }

    // Check Year Built
    if (yearBuilt.min || yearBuilt.max) {
      count++;
    }

    // Check General Occupancy
    if (generalOccupancy.length > 0) {
      generalOccupancy.map(() => {
        count++;
      });
    }

    // Check Reported Vacancy
    if (reportedVacancy) {
      count++;
    }
    setCount(count);
    return count;
  };
  return (
    <>
      <div
        className={`bg-white ${window.location.pathname === "/auctioncalendar"
          ? "p-1 -ml-0 -mr-0"
          : "p-2"
          }`}
      >
        <Typography
          color="initial"
          role="heading" aria-level="1"
          sx={{
            ml: { xs: 0, sm: 2 }, // margin-left for spacing
            fontSize: { md: "18px", xs: "16px", sm: "16px" }, // font size equivalent to h6
            fontWeight: 500, // font weight for medium text
            lineHeight: 1.5,
            mt: { sm: "15px", xs: "0px", md: "0px" }
          }}
        >
          {headertitle}
        </Typography>
        <Grid container spacing={2} mt={2} alignItems={"center"} sx={{ ml: { md: 2, xs: 0 } }}>
          <Grid size={{ xs: 12, sm: 4, md: 3 }}>
            <Autocomplete
              options={propertyState}
              getOptionLabel={(option) => option?.label || "No value"}
              onChange={handleStateChange}
              // size={"small"}
              label={"State"}
              value={selectedState}
              renderOptionLabel
              padding={"10px 0 0 18px"}

              sx={{
                '& .MuiInputLabel-root': {
                  fontSize: { xs: "16px", sm: "20px" }
                }
              }}
              textFieldSx={{
                " .MuiAutocomplete-inputRoot": {
                  // padding: "7px",
                },
                "& .MuiInputLabel-root": {
                  fontSize: "16px",
                  // textAlign: "justify",
                },
              }}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 4, md: 3 }}>
            <Autocomplete
              padding={"10px 0 0 35px"}
              onChange={handleCountyChange}
              options={allCounties}
              value={selectedCounties}
              disabled={allCounties.length <= 0}
              // size={"small"}
              sx={{
                '& .MuiInputLabel-root': {
                  fontSize: { xs: "16px", sm: "20px" }
                },
                backgroundColor: allCounties.length === 0 ? "#EBEBEB" : "#fff",
                borderColor: allCounties.length === 0 ? "#EBEBEB" : "#C5C9CD",
              }}
              getOptionLabel={(option) => option?.label || "No value"}
              groupBy={(option) => option.groupBy} // using state Name grouping the counties

              label={"County"}
              textFieldSx={{
                " .MuiAutocomplete-inputRoot": {
                  // padding: "6px",
                },
                "& .MuiInputLabel-root": {
                  fontSize: "16px",
                  // mt: "-4px",
                  // textAlign: "justify",
                },
              }}
            />
          </Grid>

          <Grid size={{ xs: 12, sm: "auto" }}>
            <span tabIndex={0} onClick={handleResetLocation}>
              <Typography
                color="#3B3B3B"
                fontWeight={400}
                fontSize={"14px"}
                onClick={handleResetLocation}
                sx={{ textDecoration: "underline", cursor: "pointer" }}
              >
                Clear Location
              </Typography>
            </span>
          </Grid>
          <Grid
            size={"auto"}
            ml={"auto"}
            textAlign={"right"}
            color={isRemoteBiddingEnable === true ? "#FF5C39" : "#3B3B3B"}
            sx={{
              fontSize: "14px",
              fontWeight: 400,
              lineHeight: "27px",
            }}
          >
            {isMobile
              ? "Only Remote Bid Enabled Properties"
              : "Only show properties available for remote bidding"}
            <TSwitch
              checked={isRemoteBiddingEnable}
              onChange={handleIsremoteBiddingEnable}
              sx={{ m: 1 }}
            />
          </Grid>
        </Grid>
      </div>

      {/* Filter Div */}
      {!isMobile && (
        <Grid
          container
          gap={2}
          alignItems={"center"}
          fontWeight={500}
          justifyContent={isMobile ? "space-between" : ""}
          paddingX={1}
          my={1}
        >
          {" "}
          <Grid
            size={"auto"}
            sx={{
              color: "#3B3B3B",
              fontSize: "18px",
              fontWeight: 500,
              lineHeight: "27px",
              pl: 2,
            }}
          >
            Filters
          </Grid>
          <Grid>
            <button
              onClick={(e) => handleOpen(e, "type")}
              aria-label="property type"
              className="min-w-44 pl-3 pr-1 py-[10px] flex justify-between items-center bg-white border border-gray-300 rounded-md text-[#9FA4AB] font-semibold shadow-sm"
            >
              <span>
                Property Type{" "}
                {selectedPropertyType?.length > 0 && (
                  <span className="text-orange-500">
                    ({selectedPropertyType?.length})
                  </span>
                )}
              </span>
              {openType ? (
                <ExpandLessIcon className="w-4 h-4" />
              ) : (
                <ExpandMoreIcon className="w-4 h-4" />
              )}
            </button>
            {!isMobile && (
              <Popover
                open={openType}
                anchorEl={anchorElType}
                onClose={() => handleClose("type")}
                elevation={1}
                slotProps={{
                  paper: {
                    sx: {
                      marginTop: { sm: 7.5, md: 8, lg: "4px" },
                      // Left:{lg:2}
                      marginLeft: "30px",
                    },
                  },
                }}
                className="xl:mt-[52px]"
                // className="max-h-[600px]"
                anchorReference={"anchorEl"}
              >
                <div className="max-w-fit md:max-h-[500px] overflow-auto mb-2 pt-1">
                  <NestedCheckboxList
                    isMobile={false}
                    options={propertyType}
                    value={selectedPropertyType}
                    setValue={setSelectedPropertyType}
                  />
                </div>
              </Popover>
            )}

            {/* <PropertyTypeAutocomplete
            options={propertyType || []}
            groupBy={(option: Option) => option.groupBy}
            sx={{ backgroundColor: "#fff" }}
            getOptionLabel={(option: Option) => option.label || "No value"}
            onChange={handlePropertyTypeChange}
            value={selectedPropertyType}
            setState={setSelectedPropertyType}
            size={"small"}
            padding={"12px 0 0 23px"}
            renderOptionLabel
            minWidth={175}
            label={`Property Type ${selectedPropertyType?.length > 0 ? <span className="text-orange-500">({selectedPropertyType?.length})</span> : " "}`}
            textFieldSx={{
              " .MuiAutocomplete-inputRoot": {
                padding: "6px",
              },
              "& .MuiInputLabel-root": {
                fontSize: "14px",
                textAlign: "justify",
              },
            }}
          /> */}
          </Grid>
          <Grid>
            {/* <button
              onClick={(e) => handleOpen(e, "status")}
              aria-label="auction status"
              className="min-w-44 pl-3 pr-1 py-[10px] flex justify-between items-center bg-white border border-gray-300 rounded-md text-[#9FA4AB] font-semibold shadow-sm"
            >
              <span>
                Auction Status{" "}
                {selectedAuctionStatus?.length > 0 && (
                  <span className="text-orange-500">
                    ({selectedAuctionStatus?.length})
                  </span>
                )}{" "}
              </span>
              {openStatus ? (
                <ExpandLessIcon className="w-4 h-4" />
              ) : (
                <ExpandMoreIcon className="w-4 h-4" />
              )}
            </button>
            {!isMobile && (
              <Popover
                open={openStatus}
                anchorEl={anchorElStatus}
                onClose={() => handleClose("status")}
                elevation={1}
                // disableScrollLock
                anchorOrigin={{
                  horizontal: "left",
                  vertical: "top",
                }}
                // transformOrigin={{
                //     vertical:"top"
                // }}
                slotProps={{
                  paper: {
                    sx: {
                      marginTop: { sm: 7, md: 8, lg: "3px" },
                      zoom: 0.98,
                      ml: 5.5,
                    },
                  },
                }}
                className="xl:mt-[53px]"
                // className="max-h-[600px]"
                anchorReference={"anchorEl"}
              >
                <div className="p-4 max-w-fit md:max-h-[500px] overflow-auto mb-2">
                  <div className="flex flex-col gap-y-2">
                    {auctionStatus.map((option, index) => {
                      return (
                        <div
                          key={`${index} ${option.id}`}
                          className="flex items-center"
                        >
                          <Checkbox
                            icon={icon}
                            checkedIcon={checkedIcon}
                            inputProps={{ 'aria-label': option.label }}
                            sx={{ marginRight: 1 }} // Using sx for margin
                            checked={selectedAuctionStatus.some(
                              (item) => item.id === option.id
                            )}
                            onChange={() => handleAuctionStatusChangeV2(option)}
                          />
                          <p
                            className="text-base font-medium cursor-pointer"
                            onClick={() => handleAuctionStatusChangeV2(option)}
                          >
                            {option.label}
                          </p>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </Popover>
            )} */}
            {/* <Autocomplete
            options={auctionStatus}
            sx={{ backgroundColor: "#fff" }}
            getOptionLabel={(option) => option.label || "No value"}
            onChange={handleAuctionStatusChange}
            size={"small"}
            renderOptionLabel
            padding={"12px 0 0 33px"}
            label={`Auction Status ${selectedAuctionStatus?.length > 0 ? <span className="text-orange-500">({selectedAuctionStatus?.length}):</span> : ""}`}
            minWidth={175}
            value={selectedAuctionStatus} // Bind selected value to state
            textFieldSx={{
              " .MuiAutocomplete-inputRoot": {
                padding: "6px",
              },
              "& .MuiInputLabel-root": {
                fontSize: "14px",
                textAlign: "center",
              },
            }}

          /> */}
          </Grid>
          <Grid>
            <button
              onClick={(e) => handleOpen(e, "more")}
              aria-label="more filter"
              className="min-w-40 pl-3 pr-1 py-[10px] flex justify-between items-center bg-white border border-gray-300 rounded-md text-[#9FA4AB] font-semibold shadow-sm"
            >
              <span>
                More Filters{" "}
                {count > 0 && (
                  <span className="text-orange-500">({count})</span>
                )}{" "}
              </span>
              {open ? (
                <ExpandLessIcon className="w-4 h-4" />
              ) : (
                <ExpandMoreIcon className="w-4 h-4" />
              )}
            </button>
            {!isMobile && (
              <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                elevation={1}
                // disableScrollLock
                // anchorOrigin={{
                //   // horizontal: "center",
                //   // vertical: "center"
                // }}
                // transformOrigin={{
                //     vertical:"top"
                // }}
                slotProps={{
                  paper: {
                    sx: {
                      marginTop: { sm: 8, md: 7.5, lg: "4px" },
                      zoom: 0.98,
                      marginLeft: { sm: 3, md: 5.5 },
                    },
                  },
                }}
                className="xl:mt-[52px]"
              // className="max-h-[600px]"
              // anchorReference={"anchorEl"}
              >
                <div className="p-4 min-w-[400px] max-w-fit md:max-h-[500px] overflow-auto mb-2">
                  <MoreFilter
                    filters={moreFilter}
                    generalOccupancy={generalOccupancy}
                    baths={baths}
                    reportedVacancy={reportedVacancy}
                    beds={beds}
                    lotSize={lotSize}
                    priceRange={priceRange}
                    yearBuilt={yearBuilt}
                    squareFootage={squareFootage}
                    setLotSize={setLotSize}
                    setBaths={setBaths}
                    setReportedVacancy={setReportedVacancy}
                    setGeneralOccupancy={setGeneralOccupancy}
                    setPriceRange={setPriceRange}
                    setBeds={setBeds}
                    setSquareFootage={setSquareFootage}
                    setYearBuilt={setYearBuilt}
                  />
                </div>
              </Popover>
            )}
            {/*  */}
          </Grid>
          <Grid size={"auto"}>
            <Typography
              color="#3B3B3B"
              fontSize={"14px"}
              fontWeight={400}
              onClick={handleResetFilters}
              sx={{ textDecoration: "underline", cursor: "pointer" }}
            >
              Clear Filters
            </Typography>
          </Grid>
        </Grid>
      )}

      {isPropertyTab && (
        <Drawer
          open={isFilterOpen}
          anchor="bottom"
          onClose={handleClose}
          sx={{ zIndex: 1300 }}
        >
          <Box height={"110dvh"} px={3} pt={2}>
            <div className="flex justify-between items-center mb-4">
              <Typography
                fontSize={16}
                fontWeight={500}
                className="font-medium"
                onClick={() => {
                  handleResetFilters();
                }}
              >
                Clear All
              </Typography>

              <Typography
                fontSize={20}
                fontWeight={500}
                className="text-xl font-medium"
              >
                Filters
              </Typography>
              <IconButton onClick={handleClose}>
                <Close />
              </IconButton>
            </div>
            <div className="flex flex-col gap-y-3">
              <button
                onClick={(e) => handleOpen(e, "type")}
                aria-label="property type"
                style={{
                  transform: "scale(1)",
                }}
                className="w-full pl-3 pr-1 py-[10px] flex justify-between items-center bg-white border text-sm border-gray-300 rounded-md text-[#9FA4AB] font-semibold shadow-sm"
              >
                <span>
                  Property Type{" "}
                  {selectedPropertyType?.length > 0 && (
                    <span className="text-orange-500">
                      ({selectedPropertyType?.length})
                    </span>
                  )}
                </span>
                {openType ? (
                  <ExpandLessIcon className="w-4 h-4" />
                ) : (
                  <ExpandMoreIcon className="w-4 h-4" />
                )}
              </button>
              {/* <button
                aria-label="Auction Status"
                onClick={(e) => handleOpen(e, "status")}
                className="min-w-40 pl-3 pr-1 py-[10px] flex justify-between items-center bg-white border text-sm border-gray-300 rounded-md text-[#9FA4AB] font-semibold shadow-sm"
              >
                <span>
                  Auction Status{" "}
                  {selectedAuctionStatus?.length > 0 && (
                    <span className="text-orange-500">
                      ({selectedAuctionStatus?.length})
                    </span>
                  )}{" "}
                </span>
                {openStatus ? (
                  <ExpandLessIcon className="w-4 h-4" />
                ) : (
                  <ExpandMoreIcon className="w-4 h-4" />
                )}
              </button> */}

              <button
                onClick={(e) => handleOpen(e, "more")}
                aria-label="more filter"
                className="min-w-40 pl-3 pr-1 py-[10px] flex justify-between items-center bg-white border text-sm border-gray-300 rounded-md text-[#9FA4AB] font-semibold shadow-sm"
              >
                <span>
                  More Filters{" "}
                  {count > 0 && (
                    <span className="text-orange-500">({count})</span>
                  )}{" "}
                </span>
                {openMore ? (
                  <ExpandLessIcon className="w-4 h-4" />
                ) : (
                  <ExpandMoreIcon className="w-4 h-4" />
                )}
              </button>
            </div>
            <ButtonComponents
              onClick={handleClose}
              label="Apply"
              sx={{ borderRadius: 2, display: "block", mt: 20, mx: "auto" }}
            />
          </Box>
        </Drawer>
      )}
      {isPropertyTab && isMobile && (
        <Drawer
          open={openType}
          anchor="bottom"
          onClose={() => handleClose("type")}
          sx={{
            zIndex: 1400,
            ".MuiPaper-root": {
              borderTopLeftRadius: "15px",
              borderTopRightRadius: "15px",
            },
          }}
        >
          <Box height={"fit-content"} pt={2}>
            <div className="flex justify-between items-center mb-4 px-5">
              <Typography
                fontSize={16}
                fontWeight={500}
                sx={{ cursor: "pointer" }}
                onClick={() => {
                  handleClose("type");
                  setSelectedPropertyType([]);
                }}
              >
                Cancel
              </Typography>
              <Typography fontSize={18} fontWeight={500}>
                Property Type
              </Typography>
              <Typography
                sx={{ cursor: "pointer" }}
                fontSize={16}
                fontWeight={500}
                onClick={() => handleClose("type")}
              >
                Done
              </Typography>
            </div>
            <NestedCheckboxList
              options={propertyType}
              value={selectedPropertyType}
              setValue={setSelectedPropertyType}
            />
          </Box>
        </Drawer>
      )}

      {isPropertyTab && isMobile && (
        <Drawer
          open={openStatus}
          anchor="bottom"
          onClose={() => handleClose("status")}
          sx={{
            zIndex: 1400,
            ".MuiPaper-root": {
              borderTopLeftRadius: "15px",
              borderTopRightRadius: "15px",
            },
          }}
        >
          <Box height={"fit-content"} minHeight={"40dvh"} px={3} pt={2}>
            <div className="flex justify-between items-center mb-4">
              <Typography
                fontSize={16}
                fontWeight={500}
                sx={{ cursor: "pointer" }}
                onClick={() => {
                  setOpenStatus(false);
                  setSelectedAuctionStatus([]);
                }}
              >
                Cancel
              </Typography>
              <Typography fontSize={18} fontWeight={500}>
                Auction Type
              </Typography>
              <Typography
                fontSize={16}
                fontWeight={500}
                sx={{ cursor: "pointer" }}
                onClick={() => handleClose("status")}
              >
                Done
              </Typography>
            </div>
            <div className="flex flex-col gap-y-2">
              {auctionStatus.map((option, index) => {
                return (
                  <div
                    key={`${index} ${option.id}`}
                    className="flex items-center"
                  >
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      sx={{ marginRight: 1 }} // Using sx for margin
                      checked={selectedAuctionStatus.some(
                        (item) => item.id === option.id
                      )}
                      onChange={() => handleAuctionStatusChangeV2(option)}
                    />
                    <p
                      className="text-base font-medium cursor-pointer"
                      onClick={() => handleAuctionStatusChangeV2(option)}
                    >
                      {option.label}
                    </p>
                  </div>
                );
              })}
            </div>
          </Box>
        </Drawer>
      )}
      {isPropertyTab && isMobile && (
        <Drawer
          open={openMore}
          anchor="bottom"
          onClose={() => handleClose("more")}
          sx={{
            zIndex: 1400,
            ".MuiPaper-root": {
              borderTopLeftRadius: "15px",
              borderTopRightRadius: "15px",
            },
          }}
        >
          <Box elevation={0} sx={{ height: "fit-content" }} px={3} pt={1}>
            <div className="flex justify-between items-center mb-4">
              <Typography
                fontSize={16}
                fontWeight={500}
                sx={{ cursor: "pointer" }}
                onClick={handleCloseMoreFilter}
              >
                Cancel
              </Typography>
              <Typography fontSize={18} fontWeight={500}>
                More Filters
              </Typography>
              <Typography
                fontSize={16}
                fontWeight={500}
                sx={{ cursor: "pointer" }}
                onClick={() => handleClose("more")}
              >
                Done
              </Typography>
            </div>
            <MoreFilter
              filters={moreFilter}
              generalOccupancy={generalOccupancy}
              baths={baths}
              reportedVacancy={reportedVacancy}
              beds={beds}
              lotSize={lotSize}
              priceRange={priceRange}
              yearBuilt={yearBuilt}
              squareFootage={squareFootage}
              setLotSize={setLotSize}
              setBaths={setBaths}
              setReportedVacancy={setReportedVacancy}
              setGeneralOccupancy={setGeneralOccupancy}
              setPriceRange={setPriceRange}
              setBeds={setBeds}
              setSquareFootage={setSquareFootage}
              setYearBuilt={setYearBuilt}
            />
          </Box>
        </Drawer>
      )}
    </>
  );
};

export default PropertiesFilterHeader;
